/**
 * Local stand-in for a missing product image.
 *
 * The app used to point at via.placeholder.com, an external service that no
 * longer resolves — so every product without a picture rendered as a broken
 * image. This is a data URI: no network, no dependency, no broken icon.
 */
export const PRODUCT_IMAGE_FALLBACK =
    'data:image/svg+xml;charset=UTF-8,' +
    encodeURIComponent(
        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 300" role="img" aria-label="Sin imagen">
  <rect width="400" height="300" fill="#e2e8f0"/>
  <g fill="none" stroke="#94a3b8" stroke-width="8" stroke-linecap="round" stroke-linejoin="round">
    <rect x="140" y="110" width="120" height="90" rx="8"/>
    <path d="M140 175l30-25 25 20 30-30 35 35"/>
  </g>
  <circle cx="172" cy="136" r="9" fill="#94a3b8"/>
</svg>`
    );

export default PRODUCT_IMAGE_FALLBACK;
